(function () {
    'use strict';

    angular
        .module('bhsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('bilan-cci', {
            abstract: true,
             parent: 'bhs'
        });
    }
})();
